var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tel-input',{ref:"telInput",attrs:{"default-country":"VN","input-options":{
    showDialCode: true,
    placeholder: 'Số điện thoại'
  },"disabled":_vm.disabled},on:{"country-changed":_vm.onCountryChanged,"input":_vm.onInput,"validate":_vm.onValidate},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})
}
var staticRenderFns = []

export { render, staticRenderFns }